import React, { createContext } from 'react';

export interface ModelFile {
  name: string;
  size: number;
  type: string;
  lastModified: number;
  url?: string; // For preview
}

// Interface for model layers
export interface ModelLayer {
  uuid: string;
  originalName: string;
  threeJsName: string;
  displayName: string;
  color?: string;
  modelName: string; // Reference to the parent model
  visible: boolean;
}

interface ModelContextType {
  uploadedModels: ModelFile[] | null;
  setUploadedModels: React.Dispatch<React.SetStateAction<ModelFile[] | null>>;
  selectedLayers: string[];
  setSelectedLayers: React.Dispatch<React.SetStateAction<string[]>>;
  modelLayers: ModelLayer[];
  setModelLayers: React.Dispatch<React.SetStateAction<ModelLayer[]>>;
  addModelLayers: (modelName: string, threeJsLayerNames: string[], originalLayerNames: string[]) => void;
  updateLayerDisplayName: (layerUuid: string, displayName: string) => void;
  updateLayerColor: (layerUuid: string, color: string) => void;
  toggleLayerVisibility: (layerName: string) => void;
  toggleAllLayersVisibility: (visible: boolean) => void;
  modelLoadingError: string | null;
  setModelLoadingError: (error: string | null) => void;
  onModelLoadingError: (modelName: string, error: string) => void;
  /** Calibration: how many real-world meters one model unit represents (default 1). */
  metersPerUnit: number;
  setMetersPerUnit: React.Dispatch<React.SetStateAction<number>>;
  /** Whether the user has explicitly set the model scale (controls gating of "Next"). */
  scaleCalibrated: boolean;
  setScaleCalibrated: React.Dispatch<React.SetStateAction<boolean>>;
}

// Create the context
export const ModelContext = createContext<ModelContextType | undefined>(undefined);
